// @ts-nocheck
import { IconLocal } from './styles'
import PropTypes from 'prop-types'

interface IconProducerProps {
  src: string
  alt?: string
  cursor?: string
}

export function IconProducer({ src, alt, cursor }: IconProducerProps) {
  const iconStyle = {
    cursor: cursor,
  }
  return <IconLocal src={src} alt={alt} style={iconStyle} />
}

IconProducer.propTypes = {
  cursor: PropTypes.string.isRequired,
}
